import React, { useState, useRef } from 'react';
import StoryContext from '../contexts/StoryContext';
import CallToActionButton from './CallToActionButton';
import CallToAction from './Covid/CallToAction';
import PrintToPDF from './PrintToPDF';
import Resources from './Resources';
import colors from '../modules/colors';
import StoryQ1 from './Covid/StoryQ1';
import StoryQ2 from './Covid/StoryQ2';
import StoryQ2A from './Covid/StoryQ2A';
import StoryQ3 from './Covid/StoryQ3';
import Conclusion from './Covid/Conclusion';

function CovidStory() {
  const [selectedState, setSelectedState] = useState(null);
  const ref = useRef(null);
  return (
    <StoryContext.Provider value={{
      selectedState,
      setSelectedState,
      primaryColor: colors.coral,
      darkColor: colors.darkCoral,
      lightColor: colors.lightCoral,
      secondaryColor: colors.lightCoral,
      contrastColor: colors.taupe,
      selectionColor: colors.grey,
      noDataColor: colors.lightGrey,
    }}
    >
      <CallToActionButton targetRef={ref} />
      <StoryQ1 />
      <div className="pagebreak80" />
      <StoryQ2 />
      <StoryQ2A />
      <div className="pagebreak80" />
      <StoryQ3 />
      <Conclusion />
      <div ref={ref} />
      <CallToAction />
      <PrintToPDF />
      <Resources />
    </StoryContext.Provider>
  );
}

export default CovidStory;
